"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Paragraph = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _customPropTypes = _interopRequireDefault(require("../../util/custom-prop-types"));
var _Paragraph = require("./Paragraph.styles");
/**
 * A block level alias for the `Text`component and is equivalent to `<Text as="p" fontType="body">`.
 *
 * @extends Text
 * @related ['Heading']
 * @since 6.0.0
 */
var Paragraph = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  return /*#__PURE__*/_react.default.createElement(_Paragraph.StyledParagraph, (0, _extends2.default)({
    as: "p",
    fontType: "body",
    ref: forwardedRef
  }, props));
});
exports.Paragraph = Paragraph;
Paragraph.displayName = 'Paragraph';
Paragraph.propTypes = {
  /**
   * Change the text alignment of the paragraph.
   *
   * Supports inline media query objects.
   */
  textAlign: _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOf(['left', 'center', 'right'])),
  /**
   * Change the text wrapping of the paragraph.
   *
   * Note: This feature is a part of [CSS Text Level 4](https://www.w3.org/TR/css-text-4/#text-wrap)
   * and not yet supported across all browsers.
   *
   * Supports inline media query objects.
   */
  textWrap: _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOf(['wrap', 'nowrap', 'balance', 'stable', 'pretty']))
};